export const sitePluginId = '60a7cbec-6b19-411d-b9fa-214d5525a832';
export const sitePluginName = 'Rise App Site Plugin';
